import React from 'react';
import { capabilities } from '../../data/offer';
import { Section } from './Section';
export function Situation() {
  return <Section index="01" label="Wat we leveren" title="Eén systeem voor de hele afspraak" data-id="element-105" data-mp="31xiyz8sg5xbe">
      <dl className="grid gap-px overflow-hidden rounded-xl border border-line bg-white/10 sm:grid-cols-3" data-id="element-106" data-mp="2nxzs0jbdgs0o">
        {capabilities.map(item => <div key={item.title} className="bg-ink p-6" data-id="element-107" data-mp="2szyqpfw630ra">
            <dt className="text-lg font-semibold tracking-tight text-white" data-id="element-108" data-mp="2e8g7l980gq3p">
              {item.title}
            </dt>
            <dd className="mt-2 text-sm leading-relaxed text-white/55" data-id="element-109" data-mp="2j19d3zbb02gu">
              {item.text}
            </dd>
          </div>)}
      </dl>
    </Section>;
}